export default [
  {
    num_code: '4',
    alpha_2_code: 'AF',
    alpha_3_code: 'AFG',
    country_en: 'Afghanistan',
    nationality_en: 'Afghan',
    country_pt: 'Afeganistão',
    country_es: 'Afganistán',
    nationality_pt: 'Afegão(ã)',
    nationality_es: 'Afgano(a)',
  },
  {
    num_code: '248',
    alpha_2_code: 'AX',
    alpha_3_code: 'ALA',
    country_en: 'Åland Islands',
    nationality_en: 'Åland Island',
    country_pt: 'Ilhas Åland',
    country_es: 'Islas Åland',
    nationality_pt: 'Ilhas Åland',
    nationality_es: 'Islas Åland',
  },
  {
    num_code: '8',
    alpha_2_code: 'AL',
    alpha_3_code: 'ALB',
    country_en: 'Albania',
    nationality_en: 'Albanian',
    country_pt: 'Albânia',
    country_es: 'Albania',
    nationality_pt: 'Albanês(a)',
    nationality_es: 'Albanés(a)',
  },
  {
    num_code: '12',
    alpha_2_code: 'DZ',
    alpha_3_code: 'DZA',
    country_en: 'Algeria',
    nationality_en: 'Algerian',
    country_pt: 'Argélia',
    country_es: 'Argelia',
    nationality_pt: 'Argelino(a)',
    nationality_es: 'Argelino(a)',
  },
  {
    num_code: '16',
    alpha_2_code: 'AS',
    alpha_3_code: 'ASM',
    country_en: 'American Samoa',
    nationality_en: 'American Samoan',
    country_pt: 'Samoa Americana',
    country_es: 'Samoa Americana',
    nationality_pt: 'Samoano(a)',
    nationality_es: 'Samoano(a)',
  },
  {
    num_code: '20',
    alpha_2_code: 'AD',
    alpha_3_code: 'AND',
    country_en: 'Andorra',
    nationality_en: 'Andorran',
    country_pt: 'Andorra',
    country_es: 'Andorra',
    nationality_pt: 'Andoriano(a)',
    nationality_es: 'Andorrano(a)',
  },
  {
    num_code: '24',
    alpha_2_code: 'AO',
    alpha_3_code: 'AGO',
    country_en: 'Angola',
    nationality_en: 'Angolan',
    country_pt: 'Angola',
    country_es: 'Angola',
    nationality_pt: 'Angolano(a)',
    nationality_es: 'Angolano(a)',
  },
  {
    num_code: '660',
    alpha_2_code: 'AI',
    alpha_3_code: 'AIA',
    country_en: 'Anguilla',
    nationality_en: 'Anguillan',
    country_pt: 'Anguilla',
    country_es: 'Anguilla',
    nationality_pt: 'Anguillense',
    nationality_es: 'Anguillense',
  },
  {
    num_code: '10',
    alpha_2_code: 'AQ',
    alpha_3_code: 'ATA',
    country_en: 'Antarctica',
    nationality_en: 'Antarctic',
    country_pt: 'Antártida',
    country_es: 'Antártida',
    nationality_pt: 'Antártida',
    nationality_es: 'Antártida',
  },
  {
    num_code: '28',
    alpha_2_code: 'AG',
    alpha_3_code: 'ATG',
    country_en: 'Antigua and Barbuda',
    nationality_en: 'Antiguan or Barbudan',
    country_pt: 'Antígua e Barbuda',
    country_es: 'Antigua y Barbuda',
    nationality_pt: 'Antiguano(a) e Barbudiano(a)',
    nationality_es: 'Antiguano(a) y Barbudiano(a)',
  },
  {
    num_code: '32',
    alpha_2_code: 'AR',
    alpha_3_code: 'ARG',
    country_en: 'Argentina',
    nationality_en: 'Argentine',
    country_pt: 'Argentina',
    country_es: 'Argentina',
    nationality_pt: 'Argentino(a)',
    nationality_es: 'Argentino(a)',
  },
  {
    num_code: '51',
    alpha_2_code: 'AM',
    alpha_3_code: 'ARM',
    country_en: 'Armenia',
    nationality_en: 'Armenian',
    country_pt: 'Armênia',
    country_es: 'Armenia',
    nationality_pt: 'Armênio(a)',
    nationality_es: 'Armenio(a)',
  },
  {
    num_code: '533',
    alpha_2_code: 'AW',
    alpha_3_code: 'ABW',
    country_en: 'Aruba',
    nationality_en: 'Aruban',
    country_pt: 'Aruba',
    country_es: 'Aruba',
    nationality_pt: 'Arubano(a)',
    nationality_es: 'Arubano(a)',
  },
  {
    num_code: '36',
    alpha_2_code: 'AU',
    alpha_3_code: 'AUS',
    country_en: 'Australia',
    nationality_en: 'Australian',
    country_pt: 'Austrália',
    country_es: 'Australia',
    nationality_pt: 'Australiano(a)',
    nationality_es: 'Australiano(a)',
  },
  {
    num_code: '40',
    alpha_2_code: 'AT',
    alpha_3_code: 'AUT',
    country_en: 'Austria',
    nationality_en: 'Austrian',
    country_pt: 'Áustria',
    country_es: 'Austria',
    nationality_pt: 'Austríaco(a)',
    nationality_es: 'Austriaco(a)',
  },
  {
    num_code: '31',
    alpha_2_code: 'AZ',
    alpha_3_code: 'AZE',
    country_en: 'Azerbaijan',
    nationality_en: 'Azerbaijani, Azeri',
    country_pt: 'Azerbaijão',
    country_es: 'Azerbaiyán',
    nationality_pt: 'Azerbaijano(a)',
    nationality_es: 'Azerbaiyano(a)',
  },
  {
    num_code: '44',
    alpha_2_code: 'BS',
    alpha_3_code: 'BHS',
    country_en: 'Bahamas',
    nationality_en: 'Bahamian',
    country_pt: 'Bahamas',
    country_es: 'Bahamas',
    nationality_pt: 'Bahamense(a)',
    nationality_es: 'Bahamense(a)',
  },
  {
    num_code: '48',
    alpha_2_code: 'BH',
    alpha_3_code: 'BHR',
    country_en: 'Bahrain',
    nationality_en: 'Bahraini',
    country_pt: 'Bahrain',
    country_es: 'Bahrain',
    nationality_pt: 'Bahreinense',
    nationality_es: 'Bahreiní',
  },
  {
    num_code: '50',
    alpha_2_code: 'BD',
    alpha_3_code: 'BGD',
    country_en: 'Bangladesh',
    nationality_en: 'Bangladeshi',
    country_pt: 'Bangladesh',
    country_es: 'Bangladesh',
    nationality_pt: 'Bangladesh',
    nationality_es: 'Bangladesh',
  },
  {
    num_code: '52',
    alpha_2_code: 'BB',
    alpha_3_code: 'BRB',
    country_en: 'Barbados',
    nationality_en: 'Barbadian',
    country_pt: 'Barbados',
    country_es: 'Barbados',
    nationality_pt: 'Barbadiano(a)',
    nationality_es: 'Barbadense',
  },
  {
    num_code: '112',
    alpha_2_code: 'BY',
    alpha_3_code: 'BLR',
    country_en: 'Belarus',
    nationality_en: 'Belarusian',
    country_pt: 'Belarus',
    country_es: 'Bielorrusia',
    nationality_pt: 'Belarus',
    nationality_es: 'Bielorruso(a)',
  },
  {
    num_code: '56',
    alpha_2_code: 'BE',
    alpha_3_code: 'BEL',
    country_en: 'Belgium',
    nationality_en: 'Belgian',
    country_pt: 'Bélgica',
    country_es: 'Bélgica',
    nationality_pt: 'Belga',
    nationality_es: 'Belga',
  },
  {
    num_code: '84',
    alpha_2_code: 'BZ',
    alpha_3_code: 'BLZ',
    country_en: 'Belize',
    nationality_en: 'Belizean',
    country_pt: 'Belize',
    country_es: 'Belice',
    nationality_pt: 'Belizenho(a)',
    nationality_es: 'Beliceño(a)',
  },
  {
    num_code: '204',
    alpha_2_code: 'BJ',
    alpha_3_code: 'BEN',
    country_en: 'Benin',
    nationality_en: 'Beninese, Beninois',
    country_pt: 'Benim',
    country_es: 'Benín',
    nationality_pt: 'Beninense',
    nationality_es: 'Beninés',
  },
  {
    num_code: '60',
    alpha_2_code: 'BM',
    alpha_3_code: 'BMU',
    country_en: 'Bermuda',
    nationality_en: 'Bermudian, Bermudan',
    country_pt: 'Bermuda',
    country_es: 'Bermuda',
    nationality_pt: 'Bermudense',
    nationality_es: 'Bermudense',
  },
  {
    num_code: '64',
    alpha_2_code: 'BT',
    alpha_3_code: 'BTN',
    country_en: 'Bhutan',
    nationality_en: 'Bhutanese',
    country_pt: 'Butão',
    country_es: 'Bután',
    nationality_pt: 'Butanês(a)',
    nationality_es: 'Butanés(a)',
  },
  {
    num_code: '68',
    alpha_2_code: 'BO',
    alpha_3_code: 'BOL',
    country_en: 'Bolivia (Plurinational State of)',
    nationality_en: 'Bolivian',
    country_pt: 'Bolívia (Estado Plurinacional)',
    country_es: 'Bolivia (Estado Plurinacional)',
    nationality_pt: 'Boliviano(a)',
    nationality_es: 'Boliviano(a)',
  },
  {
    num_code: '535',
    alpha_2_code: 'BQ',
    alpha_3_code: 'BES',
    country_en: 'Bonaire, Sint Eustatius and Saba',
    nationality_en: 'Bonaire',
    country_pt: 'Bonaire, Santo Eustáquio e Saba',
    country_es: 'Bonaire, San Eustaquio y Saba',
    nationality_pt: 'Bonairense',
    nationality_es: 'Boneriano',
  },
  {
    num_code: '70',
    alpha_2_code: 'BA',
    alpha_3_code: 'BIH',
    country_en: 'Bosnia and Herzegovina',
    nationality_en: 'Bosnian or Herzegovinian',
    country_pt: 'Bósnia e Herzegovina',
    country_es: 'Bosnia y Herzegovina',
    nationality_pt: 'Bósnio(a)',
    nationality_es: 'Bosnio(a)',
  },
  {
    num_code: '72',
    alpha_2_code: 'BW',
    alpha_3_code: 'BWA',
    country_en: 'Botswana',
    nationality_en: 'Motswana, Botswanan',
    country_pt: 'Botswana',
    country_es: 'Botswana',
    nationality_pt: 'Botsuanês(a)',
    nationality_es: 'Botsuano(a)',
  },
  {
    num_code: '74',
    alpha_2_code: 'BV',
    alpha_3_code: 'BVT',
    country_en: 'Bouvet Island',
    nationality_en: 'Bouvet Island',
    country_pt: 'Ilha Bouvet',
    country_es: 'Isla Bouvet',
    nationality_pt: 'Ilha Bouvet',
    nationality_es: 'Isla Bouvet',
  },
  {
    num_code: '76',
    alpha_2_code: 'BR',
    alpha_3_code: 'BRA',
    country_en: 'Brazil',
    nationality_en: 'Brazilian',
    country_pt: 'Brasil',
    country_es: 'Brasil',
    nationality_pt: 'Brasileiro(a)',
    nationality_es: 'Brasileño(a)',
  },
  {
    num_code: '86',
    alpha_2_code: 'IO',
    alpha_3_code: 'IOT',
    country_en: 'British Indian Ocean Territory',
    nationality_en: 'BIOT',
    country_pt: 'Território Britânico do Oceano Índico',
    country_es: 'Territorio Británico del Océano Índico',
    nationality_pt: 'Território Britânico do Oceano Índico',
    nationality_es: 'Territorio Británico del Océano Índico',
  },
  {
    num_code: '96',
    alpha_2_code: 'BN',
    alpha_3_code: 'BRN',
    country_en: 'Brunei Darussalam',
    nationality_en: 'Bruneian',
    country_pt: 'Brunei Darussalam',
    country_es: 'Brunei Darussalam',
    nationality_pt: 'Bruneano(a)',
    nationality_es: 'Bruneano(a)',
  },
  {
    num_code: '100',
    alpha_2_code: 'BG',
    alpha_3_code: 'BGR',
    country_en: 'Bulgaria',
    nationality_en: 'Bulgarian',
    country_pt: 'Bulgária',
    country_es: 'Bulgaria',
    nationality_pt: 'Búlgaro(a)',
    nationality_es: 'Búlgaro(a)',
  },
  {
    num_code: '854',
    alpha_2_code: 'BF',
    alpha_3_code: 'BFA',
    country_en: 'Burkina Faso',
    nationality_en: 'Burkinabé',
    country_pt: 'Burkina Faso',
    country_es: 'Burkina Faso',
    nationality_pt: 'Burquinense',
    nationality_es: 'Burkinabé',
  },
  {
    num_code: '108',
    alpha_2_code: 'BI',
    alpha_3_code: 'BDI',
    country_en: 'Burundi',
    nationality_en: 'Burundian',
    country_pt: 'Burundi',
    country_es: 'Burundi',
    nationality_pt: 'Burundês(a)',
    nationality_es: 'Burundés(a)',
  },
  {
    num_code: '132',
    alpha_2_code: 'CV',
    alpha_3_code: 'CPV',
    country_en: 'Cabo Verde',
    nationality_en: 'Cabo Verdean',
    country_pt: 'Cabo Verde',
    country_es: 'Cabo Verde',
    nationality_pt: 'Cabo-verdiano(a)',
    nationality_es: 'Caboverdiano(a)',
  },
  {
    num_code: '116',
    alpha_2_code: 'KH',
    alpha_3_code: 'KHM',
    country_en: 'Cambodia',
    nationality_en: 'Cambodian',
    country_pt: 'Camboja',
    country_es: 'Camboya',
    nationality_pt: 'Cambojano(a)',
    nationality_es: 'Camboyano(a)',
  },
  {
    num_code: '120',
    alpha_2_code: 'CM',
    alpha_3_code: 'CMR',
    country_en: 'Cameroon',
    nationality_en: 'Cameroonian',
    country_pt: 'Camarões',
    country_es: 'Camerún',
    nationality_pt: 'Camarones(a)',
    nationality_es: 'Camerunés(a)',
  },
  {
    num_code: '124',
    alpha_2_code: 'CA',
    alpha_3_code: 'CAN',
    country_en: 'Canada',
    nationality_en: 'Canadian',
    country_pt: 'Canadá',
    country_es: 'Canadá',
    nationality_pt: 'Canadense(a)',
    nationality_es: 'Canadiense(a)',
  },
  {
    num_code: '136',
    alpha_2_code: 'KY',
    alpha_3_code: 'CYM',
    country_en: 'Cayman Islands',
    nationality_en: 'Caymanian',
    country_pt: 'Ilhas Cayman',
    country_es: 'Islas Caimán',
    nationality_pt: 'Ilhas Cayman',
    nationality_es: 'Islas Caimán',
  },
  {
    num_code: '140',
    alpha_2_code: 'CF',
    alpha_3_code: 'CAF',
    country_en: 'Central African Republic',
    nationality_en: 'Central African',
    country_pt: 'República Centro-Africana',
    country_es: 'República Centroafricana',
    nationality_pt: 'Centro-Africano(a)',
    nationality_es: 'Centroafricano(a)',
  },
  {
    num_code: '148',
    alpha_2_code: 'TD',
    alpha_3_code: 'TCD',
    country_en: 'Chad',
    nationality_en: 'Chadian',
    country_pt: 'Chade',
    country_es: 'Chad',
    nationality_pt: 'Tchadiano(a)',
    nationality_es: 'Tchadiano(a)',
  },
  {
    num_code: '152',
    alpha_2_code: 'CL',
    alpha_3_code: 'CHL',
    country_en: 'Chile',
    nationality_en: 'Chilean',
    country_pt: 'Chile',
    country_es: 'Chile',
    nationality_pt: 'Chileno(a)',
    nationality_es: 'Chileno(a)',
  },
  {
    num_code: '156',
    alpha_2_code: 'CN',
    alpha_3_code: 'CHN',
    country_en: 'China',
    nationality_en: 'Chinese',
    country_pt: 'China',
    country_es: 'China',
    nationality_pt: 'Chinês(a)',
    nationality_es: 'Chino(a)',
  },
  {
    num_code: '162',
    alpha_2_code: 'CX',
    alpha_3_code: 'CXR',
    country_en: 'Christmas Island',
    nationality_en: 'Christmas Island',
    country_pt: 'Ilha Christmas',
    country_es: 'Isla de Navidad',
    nationality_pt: 'Ilha Christmas',
    nationality_es: 'Isla de Navidad',
  },
  {
    num_code: '166',
    alpha_2_code: 'CC',
    alpha_3_code: 'CCK',
    country_en: 'Cocos (Keeling) Islands',
    nationality_en: 'Cocos Island',
    country_pt: 'Ilhas Cocos (Keeling)',
    country_es: 'Islas Cocos (Keeling)',
    nationality_pt: 'Ilhas Cocos (Keeling)',
    nationality_es: 'Islas Cocos (Keeling)',
  },
  {
    num_code: '170',
    alpha_2_code: 'CO',
    alpha_3_code: 'COL',
    country_en: 'Colombia',
    nationality_en: 'Colombian',
    country_pt: 'Colômbia',
    country_es: 'Colombia',
    nationality_pt: 'Colombiano(a)',
    nationality_es: 'Colombiano(a)',
  },
  {
    num_code: '174',
    alpha_2_code: 'KM',
    alpha_3_code: 'COM',
    country_en: 'Comoros',
    nationality_en: 'Comoran, Comorian',
    country_pt: 'Comores',
    country_es: 'Comoras',
    nationality_pt: 'Comorense(a)',
    nationality_es: 'Comorense(a)',
  },
  {
    num_code: '178',
    alpha_2_code: 'CG',
    alpha_3_code: 'COG',
    country_en: 'Congo (Republic of the)',
    nationality_en: 'Congolese',
    country_pt: 'República do Congo',
    country_es: 'República del Congo',
    nationality_pt: 'Congolês(a)',
    nationality_es: 'Congoleño(a)',
  },
  {
    num_code: '180',
    alpha_2_code: 'CD',
    alpha_3_code: 'COD',
    country_en: 'Congo (Democratic Republic of the)',
    nationality_en: 'Congolese',
    country_pt: 'República Democrática do Congo',
    country_es: 'República Democrática del Congo',
    nationality_pt: 'Congolês(a)',
    nationality_es: 'Congoleño(a)',
  },
  {
    num_code: '184',
    alpha_2_code: 'CK',
    alpha_3_code: 'COK',
    country_en: 'Cook Islands',
    nationality_en: 'Cook Island',
    country_pt: 'Ilhas Cook',
    country_es: 'Islas Cook',
    nationality_pt: 'Ilhas Cook',
    nationality_es: 'Islas Cook',
  },
  {
    num_code: '188',
    alpha_2_code: 'CR',
    alpha_3_code: 'CRI',
    country_en: 'Costa Rica',
    nationality_en: 'Costa Rican',
    country_pt: 'Costa Rica',
    country_es: 'Costa Rica',
    nationality_pt: 'Costarriquenho(a)',
    nationality_es: 'Costarricense',
  },
  {
    num_code: '384',
    alpha_2_code: 'CI',
    alpha_3_code: 'CIV',
    country_en: "Côte d'Ivoire",
    nationality_en: 'Ivorian',
    country_pt: 'Costa do Marfim',
    country_es: 'Costa de Marfil',
    nationality_pt: 'Costa-Marfinense(a)',
    nationality_es: 'Costamarfileño(a)',
  },
  {
    num_code: '191',
    alpha_2_code: 'HR',
    alpha_3_code: 'HRV',
    country_en: 'Croatia',
    nationality_en: 'Croatian',
    country_pt: 'Croácia',
    country_es: 'Croacia',
    nationality_pt: 'Croata(a)',
    nationality_es: 'Croata(a)',
  },
  {
    num_code: '192',
    alpha_2_code: 'CU',
    alpha_3_code: 'CUB',
    country_en: 'Cuba',
    nationality_en: 'Cuban',
    country_pt: 'Cuba',
    country_es: 'Cuba',
    nationality_pt: 'Cubano(a)',
    nationality_es: 'Cubano(a)',
  },
  {
    num_code: '531',
    alpha_2_code: 'CW',
    alpha_3_code: 'CUW',
    country_en: 'Curaçao',
    nationality_en: 'Curaçaoan',
    country_pt: 'Curaçao',
    country_es: 'Curaçao',
    nationality_pt: 'Curazoleiro(a)',
    nationality_es: 'Curazoleño(a)',
  },
  {
    num_code: '196',
    alpha_2_code: 'CY',
    alpha_3_code: 'CYP',
    country_en: 'Cyprus',
    nationality_en: 'Cypriot',
    country_pt: 'Chipre',
    country_es: 'Chipre',
    nationality_pt: 'Chipriota',
    nationality_es: 'Chipriota',
  },
  {
    num_code: '203',
    alpha_2_code: 'CZ',
    alpha_3_code: 'CZE',
    country_en: 'Czech Republic',
    nationality_en: 'Czech',
    country_pt: 'República Tcheca',
    country_es: 'República Checa',
    nationality_pt: 'Tcheco(a)',
    nationality_es: 'Checo(a)',
  },
  {
    num_code: '208',
    alpha_2_code: 'DK',
    alpha_3_code: 'DNK',
    country_en: 'Denmark',
    nationality_en: 'Danish',
    country_pt: 'Dinamarca',
    country_es: 'Dinamarca',
    nationality_pt: 'Dinamarquês(a)',
    nationality_es: 'Danés(a)',
  },
  {
    num_code: '262',
    alpha_2_code: 'DJ',
    alpha_3_code: 'DJI',
    country_en: 'Djibouti',
    nationality_en: 'Djiboutian',
    country_pt: 'Djibouti',
    country_es: 'Djibouti',
    nationality_pt: 'Djibuti',
    nationality_es: 'Djibutiense',
  },
  {
    num_code: '212',
    alpha_2_code: 'DM',
    alpha_3_code: 'DMA',
    country_en: 'Dominica',
    nationality_en: 'Dominican',
    country_pt: 'Dominica',
    country_es: 'Dominica',
    nationality_pt: 'Dominicano(a)',
    nationality_es: 'Dominicano(a)',
  },
  {
    num_code: '214',
    alpha_2_code: 'DO',
    alpha_3_code: 'DOM',
    country_en: 'Dominican Republic',
    nationality_en: 'Dominican',
    country_pt: 'República Dominicana',
    country_es: 'República Dominicana',
    nationality_pt: 'Dominicano(a)',
    nationality_es: 'Dominicano(a)',
  },
  {
    num_code: '218',
    alpha_2_code: 'EC',
    alpha_3_code: 'ECU',
    country_en: 'Ecuador',
    nationality_en: 'Ecuadorian',
    country_pt: 'Equador',
    country_es: 'Ecuador',
    nationality_pt: 'Equatoriano(a)',
    nationality_es: 'Ecuatoriano(a)',
  },
  {
    num_code: '818',
    alpha_2_code: 'EG',
    alpha_3_code: 'EGY',
    country_en: 'Egypt',
    nationality_en: 'Egyptian',
    country_pt: 'Egito',
    country_es: 'Egipto',
    nationality_pt: 'Egípcio(a)',
    nationality_es: 'Egipcio(a)',
  },
  {
    num_code: '222',
    alpha_2_code: 'SV',
    alpha_3_code: 'SLV',
    country_en: 'El Salvador',
    nationality_en: 'Salvadoran',
    country_pt: 'El Salvador',
    country_es: 'El Salvador',
    nationality_pt: 'Salvadoranho(a)',
    nationality_es: 'Salvadoreño(a)',
  },
  {
    num_code: '226',
    alpha_2_code: 'GQ',
    alpha_3_code: 'GNQ',
    country_en: 'Equatorial Guinea',
    nationality_en: 'Equatorial Guinean, Equatoguinean',
    country_pt: 'Guiné Equatorial',
    country_es: 'Guinea Ecuatorial',
    nationality_pt: 'Guineano(a)',
    nationality_es: 'Guineano(a)',
  },
  {
    num_code: '232',
    alpha_2_code: 'ER',
    alpha_3_code: 'ERI',
    country_en: 'Eritrea',
    nationality_en: 'Eritrean',
    country_pt: 'Eritreia',
    country_es: 'Eritrea',
    nationality_pt: 'Eritreu(a)',
    nationality_es: 'Eritreo(a)',
  },
  {
    num_code: '233',
    alpha_2_code: 'EE',
    alpha_3_code: 'EST',
    country_en: 'Estonia',
    nationality_en: 'Estonian',
    country_pt: 'Estônia',
    country_es: 'Estonia',
    nationality_pt: 'Estônio(a)',
    nationality_es: 'Estonio(a)',
  },
  {
    num_code: '231',
    alpha_2_code: 'ET',
    alpha_3_code: 'ETH',
    country_en: 'Ethiopia',
    nationality_en: 'Ethiopian',
    country_pt: 'Etiópia',
    country_es: 'Etiopía',
    nationality_pt: 'Etíope(a)',
    nationality_es: 'Etíope(a)',
  },
  {
    num_code: '238',
    alpha_2_code: 'FK',
    alpha_3_code: 'FLK',
    country_en: 'Falkland Islands (Malvinas)',
    nationality_en: 'Falkland Island',
    country_pt: 'Ilhas Malvinas',
    country_es: 'Islas Malvinas',
    nationality_pt: 'Ilhas Malvinas',
    nationality_es: 'Islas Malvinas',
  },
  {
    num_code: '234',
    alpha_2_code: 'FO',
    alpha_3_code: 'FRO',
    country_en: 'Faroe Islands',
    nationality_en: 'Faroese',
    country_pt: 'Ilhas Faroé',
    country_es: 'Islas Feroe',
    nationality_pt: 'Faroês(esa)',
    nationality_es: 'Feroés(esa)',
  },
  {
    num_code: '242',
    alpha_2_code: 'FJ',
    alpha_3_code: 'FJI',
    country_en: 'Fiji',
    nationality_en: 'Fijian',
    country_pt: 'Fiji',
    country_es: 'Fiyi',
    nationality_pt: 'Fijiano(a)',
    nationality_es: 'Fijiano(a)',
  },
  {
    num_code: '246',
    alpha_2_code: 'FI',
    alpha_3_code: 'FIN',
    country_en: 'Finland',
    nationality_en: 'Finnish',
    country_pt: 'Finlândia',
    country_es: 'Finlandia',
    nationality_pt: 'Finlandês(a)',
    nationality_es: 'Finlandés(a)',
  },
  {
    num_code: '250',
    alpha_2_code: 'FR',
    alpha_3_code: 'FRA',
    country_en: 'France',
    nationality_en: 'French',
    country_pt: 'França',
    country_es: 'Francia',
    nationality_pt: 'Francês(a)',
    nationality_es: 'Francés(a)',
  },
  {
    num_code: '254',
    alpha_2_code: 'GF',
    alpha_3_code: 'GUF',
    country_en: 'French Guiana',
    nationality_en: 'French Guianese',
    country_pt: 'Guiana Francesa',
    country_es: 'Guayana Francesa',
    nationality_pt: 'Guianense',
    nationality_es: 'Guayanesa',
  },
  {
    num_code: '258',
    alpha_2_code: 'PF',
    alpha_3_code: 'PYF',
    country_en: 'French Polynesia',
    nationality_en: 'French Polynesian',
    country_pt: 'Polinésia Francesa',
    country_es: 'Polinesia Francesa',
    nationality_pt: 'Polinésio(a)',
    nationality_es: 'Polinesio(a)',
  },
  {
    num_code: '260',
    alpha_2_code: 'TF',
    alpha_3_code: 'ATF',
    country_en: 'French Southern Territories',
    nationality_en: 'French Southern Territories',
    country_pt: 'Territórios Austrais Franceses',
    country_es: 'Territorios del Sur Franceses',
    nationality_pt: 'Territórios Franceses do Sul',
    nationality_es: 'Territorios del Sur Franceses',
  },
  {
    num_code: '266',
    alpha_2_code: 'GA',
    alpha_3_code: 'GAB',
    country_en: 'Gabon',
    nationality_en: 'Gabonese',
    country_pt: 'Gabão',
    country_es: 'Gabón',
    nationality_pt: 'Gabonês(a)',
    nationality_es: 'Gabonés(a)',
  },
  {
    num_code: '270',
    alpha_2_code: 'GM',
    alpha_3_code: 'GMB',
    country_en: 'Gambia',
    nationality_en: 'Gambian',
    country_pt: 'Gâmbia',
    country_es: 'Gambia',
    nationality_pt: 'Gambiano(a)',
    nationality_es: 'Gambiano(a)',
  },
  {
    num_code: '268',
    alpha_2_code: 'GE',
    alpha_3_code: 'GEO',
    country_en: 'Georgia',
    nationality_en: 'Georgian',
    country_pt: 'Geórgia',
    country_es: 'Georgia',
    nationality_pt: 'Georgiano(a)',
    nationality_es: 'Georgiano(a)',
  },
  {
    num_code: '276',
    alpha_2_code: 'DE',
    alpha_3_code: 'DEU',
    country_en: 'Germany',
    nationality_en: 'German',
    country_pt: 'Alemanha',
    country_es: 'Alemania',
    nationality_pt: 'Alemão(ã)',
    nationality_es: 'Alemán(a)',
  },
  {
    num_code: '288',
    alpha_2_code: 'GH',
    alpha_3_code: 'GHA',
    country_en: 'Ghana',
    nationality_en: 'Ghanaian',
    country_pt: 'Gana',
    country_es: 'Ghana',
    nationality_pt: 'Ghanês(a)',
    nationality_es: 'Ghanés(a)',
  },
  {
    num_code: '292',
    alpha_2_code: 'GI',
    alpha_3_code: 'GIB',
    country_en: 'Gibraltar',
    nationality_en: 'Gibraltar',
    country_pt: 'Gibraltar',
    country_es: 'Gibraltar',
    nationality_pt: 'Gibraltarenses',
    nationality_es: 'Gibraltareños',
  },
  {
    num_code: '300',
    alpha_2_code: 'GR',
    alpha_3_code: 'GRC',
    country_en: 'Greece',
    nationality_en: 'Greek, Hellenic',
    country_pt: 'Grécia',
    country_es: 'Grecia',
    nationality_pt: 'Grego(a)',
    nationality_es: 'Griego(a)',
  },
  {
    num_code: '304',
    alpha_2_code: 'GL',
    alpha_3_code: 'GRL',
    country_en: 'Greenland',
    nationality_en: 'Greenlandic',
    country_pt: 'Groenlândia',
    country_es: 'Groenlandia',
    nationality_pt: 'Groenlandês(a)',
    nationality_es: 'Groenlandés(a)',
  },
  {
    num_code: '308',
    alpha_2_code: 'GD',
    alpha_3_code: 'GRD',
    country_en: 'Grenada',
    nationality_en: 'Grenadian',
    country_pt: 'Granada',
    country_es: 'Granada',
    nationality_pt: 'Granadense',
    nationality_es: 'Granadino(a)',
  },
  {
    num_code: '312',
    alpha_2_code: 'GP',
    alpha_3_code: 'GLP',
    country_en: 'Guadeloupe',
    nationality_en: 'Guadeloupe',
    country_pt: 'Guadalupe',
    country_es: 'Guadalupe',
    nationality_pt: 'Guadeloupiano(a)',
    nationality_es: 'Guadalupense',
  },
  {
    num_code: '316',
    alpha_2_code: 'GU',
    alpha_3_code: 'GUM',
    country_en: 'Guam',
    nationality_en: 'Guamanian, Guambat',
    country_pt: 'Guam',
    country_es: 'Guam',
    nationality_pt: 'Guam',
    nationality_es: 'Guam',
  },
  {
    num_code: '320',
    alpha_2_code: 'GT',
    alpha_3_code: 'GTM',
    country_en: 'Guatemala',
    nationality_en: 'Guatemalan',
    country_pt: 'Guatemala',
    country_es: 'Guatemala',
    nationality_pt: 'Guatemalteco(a)',
    nationality_es: 'Guatemalteco(a)',
  },
  {
    num_code: '831',
    alpha_2_code: 'GG',
    alpha_3_code: 'GGY',
    country_en: 'Guernsey',
    nationality_en: 'Channel Island',
    country_pt: 'Guernsey',
    country_es: 'Guernsey',
    nationality_pt: 'Guernseyano(a)',
    nationality_es: 'Guernseyano(a)',
  },
  {
    num_code: '324',
    alpha_2_code: 'GN',
    alpha_3_code: 'GIN',
    country_en: 'Guinea',
    nationality_en: 'Guinean',
    country_pt: 'Guiné',
    country_es: 'Guinea',
    nationality_pt: 'Guineano(a)',
    nationality_es: 'Guineano(a)',
  },
  {
    num_code: '624',
    alpha_2_code: 'GW',
    alpha_3_code: 'GNB',
    country_en: 'Guinea-Bissau',
    nationality_en: 'Bissau-Guinean',
    country_pt: 'Guiné-Bissau',
    country_es: 'Guinea-Bissau',
    nationality_pt: 'Guineense(a)',
    nationality_es: 'Guineense(a)',
  },
  {
    num_code: '328',
    alpha_2_code: 'GY',
    alpha_3_code: 'GUY',
    country_en: 'Guyana',
    nationality_en: 'Guyanese',
    country_pt: 'Guiana',
    country_es: 'Guyana',
    nationality_pt: 'Guianês(a)',
    nationality_es: 'Guayano(a)',
  },
  {
    num_code: '332',
    alpha_2_code: 'HT',
    alpha_3_code: 'HTI',
    country_en: 'Haiti',
    nationality_en: 'Haitian',
    country_pt: 'Haiti',
    country_es: 'Haití',
    nationality_pt: 'Haitiano(a)',
    nationality_es: 'Haitiano(a)',
  },
  {
    num_code: '334',
    alpha_2_code: 'HM',
    alpha_3_code: 'HMD',
    country_en: 'Heard Island and McDonald Islands',
    nationality_en: 'Heard Island or McDonald Islands',
    country_pt: 'Ilha Heard e Ilhas McDonald',
    country_es: 'Isla Heard y las Islas McDonald',
    nationality_pt: 'Ilha Heard e Ilhas McDonald',
    nationality_es: 'Isla Heard y las Islas McDonald',
  },
  {
    num_code: '336',
    alpha_2_code: 'VA',
    alpha_3_code: 'VAT',
    country_en: 'Vatican City State',
    nationality_en: 'Vatican',
    country_pt: 'Estado da Cidade do Vaticano',
    country_es: 'Estado de la Ciudad del Vaticano',
    nationality_pt: 'Vaticano',
    nationality_es: 'Vaticano',
  },
  {
    num_code: '340',
    alpha_2_code: 'HN',
    alpha_3_code: 'HND',
    country_en: 'Honduras',
    nationality_en: 'Honduran',
    country_pt: 'Honduras',
    country_es: 'Honduras',
    nationality_pt: 'Hondurenho(a)',
    nationality_es: 'Hondureño(a)',
  },
  {
    num_code: '344',
    alpha_2_code: 'HK',
    alpha_3_code: 'HKG',
    country_en: 'Hong Kong',
    nationality_en: 'Hong Kong, Hong Kongese',
    country_pt: 'Hong Kong',
    country_es: 'Hong Kong',
    nationality_pt: 'Hong Kong',
    nationality_es: 'Hong Kong',
  },
  {
    num_code: '348',
    alpha_2_code: 'HU',
    alpha_3_code: 'HUN',
    country_en: 'Hungary',
    nationality_en: 'Hungarian, Magyar',
    country_pt: 'Hungria',
    country_es: 'Hungría',
    nationality_pt: 'Húngaro(a)',
    nationality_es: 'Húngaro(a)',
  },
  {
    num_code: '352',
    alpha_2_code: 'IS',
    alpha_3_code: 'ISL',
    country_en: 'Iceland',
    nationality_en: 'Icelandic',
    country_pt: 'Islândia',
    country_es: 'Islandia',
    nationality_pt: 'Islandês(esa)',
    nationality_es: 'Islandés(esa)',
  },
  {
    num_code: '356',
    alpha_2_code: 'IN',
    alpha_3_code: 'IND',
    country_en: 'India',
    nationality_en: 'Indian',
    country_pt: 'Índia',
    country_es: 'India',
    nationality_pt: 'Indiano(a)',
    nationality_es: 'Indio(a)',
  },
  {
    num_code: '360',
    alpha_2_code: 'ID',
    alpha_3_code: 'IDN',
    country_en: 'Indonesia',
    nationality_en: 'Indonesian',
    country_pt: 'Indonésia',
    country_es: 'Indonesia',
    nationality_pt: 'Indonésio(a)',
    nationality_es: 'Indonesio(a)',
  },
  {
    num_code: '364',
    alpha_2_code: 'IR',
    alpha_3_code: 'IRN',
    country_en: 'Iran',
    nationality_en: 'Iranian, Persian',
    country_pt: 'Irã',
    country_es: 'Irán',
    nationality_pt: 'Iraniano(a)',
    nationality_es: 'Iraní(a)',
  },
  {
    num_code: '368',
    alpha_2_code: 'IQ',
    alpha_3_code: 'IRQ',
    country_en: 'Iraq',
    nationality_en: 'Iraqi',
    country_pt: 'Iraque',
    country_es: 'Irak',
    nationality_pt: 'Iraquiano(a)',
    nationality_es: 'Iraquí(a)',
  },
  {
    num_code: '372',
    alpha_2_code: 'IE',
    alpha_3_code: 'IRL',
    country_en: 'Ireland',
    nationality_en: 'Irish',
    country_pt: 'Irlanda',
    country_es: 'Irlanda',
    nationality_pt: 'Irlandês(esa)',
    nationality_es: 'Irlandés(esa)',
  },
  {
    num_code: '833',
    alpha_2_code: 'IM',
    alpha_3_code: 'IMN',
    country_en: 'Isle of Man',
    nationality_en: 'Manx',
    country_pt: 'Ilha de Man',
    country_es: 'Isla de Man',
    nationality_pt: 'Ilha de Man',
    nationality_es: 'Isla de Man',
  },
  {
    num_code: '376',
    alpha_2_code: 'IL',
    alpha_3_code: 'ISR',
    country_en: 'Israel',
    nationality_en: 'Israeli',
    country_pt: 'Israel',
    country_es: 'Israel',
    nationality_pt: 'Israelita(a)',
    nationality_es: 'Israelita(a)',
  },
  {
    num_code: '380',
    alpha_2_code: 'IT',
    alpha_3_code: 'ITA',
    country_en: 'Italy',
    nationality_en: 'Italian',
    country_pt: 'Itália',
    country_es: 'Italia',
    nationality_pt: 'Italiano(a)',
    nationality_es: 'Italiano(a)',
  },
  {
    num_code: '388',
    alpha_2_code: 'JM',
    alpha_3_code: 'JAM',
    country_en: 'Jamaica',
    nationality_en: 'Jamaican',
    country_pt: 'Jamaica',
    country_es: 'Jamaica',
    nationality_pt: 'Jamaiqueno(a)',
    nationality_es: 'Jamaiquino(a)',
  },
  {
    num_code: '392',
    alpha_2_code: 'JP',
    alpha_3_code: 'JPN',
    country_en: 'Japan',
    nationality_en: 'Japanese',
    country_pt: 'Japão',
    country_es: 'Japón',
    nationality_pt: 'Japonês(a)',
    nationality_es: 'Japonés(a)',
  },
  {
    num_code: '832',
    alpha_2_code: 'JE',
    alpha_3_code: 'JEY',
    country_en: 'Jersey',
    nationality_en: 'Channel Island',
    country_pt: 'Jersey',
    country_es: 'Jersey',
    nationality_pt: 'Jerseyano(a)',
    nationality_es: 'Jerseyano(a)',
  },
  {
    num_code: '400',
    alpha_2_code: 'JO',
    alpha_3_code: 'JOR',
    country_en: 'Jordan',
    nationality_en: 'Jordanian',
    country_pt: 'Jordânia',
    country_es: 'Jordania',
    nationality_pt: 'Jordaniano(a)',
    nationality_es: 'Jordaniano(a)',
  },
  {
    num_code: '398',
    alpha_2_code: 'KZ',
    alpha_3_code: 'KAZ',
    country_en: 'Kazakhstan',
    nationality_en: 'Kazakhstani, Kazakh',
    country_pt: 'Cazaquistão',
    country_es: 'Kazajistán',
    nationality_pt: 'Cazaque',
    nationality_es: 'Kazajo',
  },
  {
    num_code: '404',
    alpha_2_code: 'KE',
    alpha_3_code: 'KEN',
    country_en: 'Kenya',
    nationality_en: 'Kenyan',
    country_pt: 'Quênia',
    country_es: 'Kenia',
    nationality_pt: 'Queniano(a)',
    nationality_es: 'Keniano(a)',
  },
  {
    num_code: '296',
    alpha_2_code: 'KI',
    alpha_3_code: 'KIR',
    country_en: 'Kiribati',
    nationality_en: 'I-Kiribati',
    country_pt: 'Kiribati',
    country_es: 'Kiribati',
    nationality_pt: 'Kiribati',
    nationality_es: 'Kiribati',
  },
  {
    num_code: '408',
    alpha_2_code: 'KP',
    alpha_3_code: 'PRK',
    country_en: "Korea (Democratic People's Republic of)",
    nationality_en: 'North Korean',
    country_pt: 'Coreia do Norte',
    country_es: 'Corea del Norte',
    nationality_pt: 'Norte-coreano(a)',
    nationality_es: 'Norcoreano(a)',
  },
  {
    num_code: '410',
    alpha_2_code: 'KR',
    alpha_3_code: 'KOR',
    country_en: 'Korea (Republic of)',
    nationality_en: 'South Korean',
    country_pt: 'Coreia do Sul',
    country_es: 'Corea del Sur',
    nationality_pt: 'Sul-coreano(a)',
    nationality_es: 'Surcoreano(a)',
  },
  {
    num_code: '414',
    alpha_2_code: 'KW',
    alpha_3_code: 'KWT',
    country_en: 'Kuwait',
    nationality_en: 'Kuwaiti',
    country_pt: 'Kuwait',
    country_es: 'Kuwait',
    nationality_pt: 'Kuwaitiano(a)',
    nationality_es: 'Kuwaitiano(a)',
  },
  {
    num_code: '417',
    alpha_2_code: 'KG',
    alpha_3_code: 'KGZ',
    country_en: 'Kyrgyzstan',
    nationality_en: 'Kyrgyzstani, Kyrgyz, Kirgiz, Kirghiz',
    country_pt: 'Quirguistão',
    country_es: 'Kirguistán',
    nationality_pt: 'Quirguiz(a)',
    nationality_es: 'Kirguís(es)',
  },
  {
    num_code: '418',
    alpha_2_code: 'LA',
    alpha_3_code: 'LAO',
    country_en: "Lao People's Democratic Republic",
    nationality_en: 'Lao, Laotian',
    country_pt: 'República Popular Democrática do Laos',
    country_es: 'República Popular Democrática de Laos',
    nationality_pt: 'Laociano(a)',
    nationality_es: 'Laosiano(a)',
  },
  {
    num_code: '428',
    alpha_2_code: 'LV',
    alpha_3_code: 'LVA',
    country_en: 'Latvia',
    nationality_en: 'Latvian',
    country_pt: 'Letônia',
    country_es: 'Letonia',
    nationality_pt: 'Letão(ã)',
    nationality_es: 'Letón(a)',
  },
  {
    num_code: '422',
    alpha_2_code: 'LB',
    alpha_3_code: 'LBN',
    country_en: 'Lebanon',
    nationality_en: 'Lebanese',
    country_pt: 'Líbano',
    country_es: 'Líbano',
    nationality_pt: 'Libanês(a)',
    nationality_es: 'Libanés(a)',
  },
  {
    num_code: '426',
    alpha_2_code: 'LS',
    alpha_3_code: 'LSO',
    country_en: 'Lesotho',
    nationality_en: 'Basotho',
    country_pt: 'Lesoto',
    country_es: 'Lesotho',
    nationality_pt: 'Lesotense(a)',
    nationality_es: 'Lesotense(a)',
  },
  {
    num_code: '430',
    alpha_2_code: 'LR',
    alpha_3_code: 'LBR',
    country_en: 'Liberia',
    nationality_en: 'Liberian',
    country_pt: 'Libéria',
    country_es: 'Liberia',
    nationality_pt: 'Liberiano(a)',
    nationality_es: 'Liberiano(a)',
  },
  {
    num_code: '434',
    alpha_2_code: 'LY',
    alpha_3_code: 'LBY',
    country_en: 'Libya',
    nationality_en: 'Libyan',
    country_pt: 'Líbia',
    country_es: 'Libia',
    nationality_pt: 'Libiano(a)',
    nationality_es: 'Libio(a)',
  },
  {
    num_code: '438',
    alpha_2_code: 'LI',
    alpha_3_code: 'LIE',
    country_en: 'Liechtenstein',
    nationality_en: 'Liechtenstein',
    country_pt: 'Liechtenstein',
    country_es: 'Liechtenstein',
    nationality_pt: 'Liechtensteinense',
    nationality_es: 'Liechtensteinense',
  },
  {
    num_code: '440',
    alpha_2_code: 'LT',
    alpha_3_code: 'LTU',
    country_en: 'Lithuania',
    nationality_en: 'Lithuanian',
    country_pt: 'Lituânia',
    country_es: 'Lituania',
    nationality_pt: 'Lituano(a)',
    nationality_es: 'Lituano(a)',
  },
  {
    num_code: '442',
    alpha_2_code: 'LU',
    alpha_3_code: 'LUX',
    country_en: 'Luxembourg',
    nationality_en: 'Luxembourg, Luxembourgish',
    country_pt: 'Luxemburgo',
    country_es: 'Luxemburgo',
    nationality_pt: 'Luxemburguês(esa)',
    nationality_es: 'Luxemburgués(esa)',
  },
  {
    num_code: '446',
    alpha_2_code: 'MO',
    alpha_3_code: 'MAC',
    country_en: 'Macao',
    nationality_en: 'Macanese, Chinese',
    country_pt: 'Macau',
    country_es: 'Macao',
    nationality_pt: 'Macaense',
    nationality_es: 'Macanés',
  },
  {
    num_code: '807',
    alpha_2_code: 'MK',
    alpha_3_code: 'MKD',
    country_en: 'Macedonia (the former Yugoslav Republic of)',
    nationality_en: 'Macedonian',
    country_pt: 'Macedônia do Norte',
    country_es: 'Macedonia del Norte',
    nationality_pt: 'Macedônio(a)',
    nationality_es: 'Macedonio(a)',
  },
  {
    num_code: '450',
    alpha_2_code: 'MG',
    alpha_3_code: 'MDG',
    country_en: 'Madagascar',
    nationality_en: 'Malagasy',
    country_pt: 'Madagascar',
    country_es: 'Madagascar',
    nationality_pt: 'Madagascar',
    nationality_es: 'Madagascar',
  },
  {
    num_code: '454',
    alpha_2_code: 'MW',
    alpha_3_code: 'MWI',
    country_en: 'Malawi',
    nationality_en: 'Malawian',
    country_pt: 'Malawi',
    country_es: 'Malawi',
    nationality_pt: 'Malauiano(a)',
    nationality_es: 'Malauiano(a)',
  },
  {
    num_code: '458',
    alpha_2_code: 'MY',
    alpha_3_code: 'MYS',
    country_en: 'Malaysia',
    nationality_en: 'Malaysian',
    country_pt: 'Malásia',
    country_es: 'Malasia',
    nationality_pt: 'Malásio(a)',
    nationality_es: 'Malayo(a)',
  },
  {
    num_code: '462',
    alpha_2_code: 'MV',
    alpha_3_code: 'MDV',
    country_en: 'Maldives',
    nationality_en: 'Maldivian',
    country_pt: 'Maldivas',
    country_es: 'Maldivas',
    nationality_pt: 'Maldívio(a)',
    nationality_es: 'Maldivo(a)',
  },
  {
    num_code: '466',
    alpha_2_code: 'ML',
    alpha_3_code: 'MLI',
    country_en: 'Mali',
    nationality_en: 'Malian, Malinese',
    country_pt: 'Mali',
    country_es: 'Mali',
    nationality_pt: 'Maliano(a)',
    nationality_es: 'Maliano(a)',
  },
  {
    num_code: '470',
    alpha_2_code: 'MT',
    alpha_3_code: 'MLT',
    country_en: 'Malta',
    nationality_en: 'Maltese',
    country_pt: 'Malta',
    country_es: 'Malta',
    nationality_pt: 'Maltês(a)',
    nationality_es: 'Maltés(a)',
  },
  {
    num_code: '584',
    alpha_2_code: 'MH',
    alpha_3_code: 'MHL',
    country_en: 'Marshall Islands',
    nationality_en: 'Marshallese',
    country_pt: 'Ilhas Marshall',
    country_es: 'Islas Marshall',
    nationality_pt: 'Marshallês(a)',
    nationality_es: 'Marshalés(a)',
  },
  {
    num_code: '474',
    alpha_2_code: 'MQ',
    alpha_3_code: 'MTQ',
    country_en: 'Martinique',
    nationality_en: 'Martiniquais, Martinican',
    country_pt: 'Martinica',
    country_es: 'Martinica',
    nationality_pt: 'Martinicano(a)',
    nationality_es: 'Martiniqueño(a)',
  },
  {
    num_code: '478',
    alpha_2_code: 'MR',
    alpha_3_code: 'MRT',
    country_en: 'Mauritania',
    nationality_en: 'Mauritanian',
    country_pt: 'Mauritânia',
    country_es: 'Mauritania',
    nationality_pt: 'Mauritano(a)',
    nationality_es: 'Mauritano(a)',
  },
  {
    num_code: '480',
    alpha_2_code: 'MU',
    alpha_3_code: 'MUS',
    country_en: 'Mauritius',
    nationality_en: 'Mauritian',
    country_pt: 'Maurício',
    country_es: 'Mauricio',
    nationality_pt: 'Maurício',
    nationality_es: 'Mauricio',
  },
  {
    num_code: '175',
    alpha_2_code: 'YT',
    alpha_3_code: 'MYT',
    country_en: 'Mayotte',
    nationality_en: 'Mahoran',
    country_pt: 'Mayotte',
    country_es: 'Mayotte',
    nationality_pt: 'Mayotte',
    nationality_es: 'Mayotte',
  },
  {
    num_code: '484',
    alpha_2_code: 'MX',
    alpha_3_code: 'MEX',
    country_en: 'Mexico',
    nationality_en: 'Mexican',
    country_pt: 'México',
    country_es: 'México',
    nationality_pt: 'Mexicano(a)',
    nationality_es: 'Mexicano(a)',
  },
  {
    num_code: '583',
    alpha_2_code: 'FM',
    alpha_3_code: 'FSM',
    country_en: 'Micronesia (Federated States of)',
    nationality_en: 'Micronesian',
    country_pt: 'Micronesia (Estados Federados da)',
    country_es: 'Micronesia (Estados Federados de)',
    nationality_pt: 'Micronésio(a)',
    nationality_es: 'Micronésico(a)',
  },
  {
    num_code: '498',
    alpha_2_code: 'MD',
    alpha_3_code: 'MDA',
    country_en: 'Moldova (Republic of)',
    nationality_en: 'Moldovan',
    country_pt: 'Moldávia',
    country_es: 'Moldavia',
    nationality_pt: 'Moldavo(a)',
    nationality_es: 'Moldavo(a)',
  },
  {
    num_code: '492',
    alpha_2_code: 'MC',
    alpha_3_code: 'MCO',
    country_en: 'Monaco',
    nationality_en: 'Monégasque, Monacan',
    country_pt: 'Mônaco',
    country_es: 'Mónaco',
    nationality_pt: 'Monaco(a)',
    nationality_es: 'Monaco(a)',
  },
  {
    num_code: '496',
    alpha_2_code: 'MN',
    alpha_3_code: 'MNG',
    country_en: 'Mongolia',
    nationality_en: 'Mongolian',
    country_pt: 'Mongólia',
    country_es: 'Mongolia',
    nationality_pt: 'Mongol(a)',
    nationality_es: 'Mongol(a)',
  },
  {
    num_code: '499',
    alpha_2_code: 'ME',
    alpha_3_code: 'MNE',
    country_en: 'Montenegro',
    nationality_en: 'Montenegrin',
    country_pt: 'Montenegro',
    country_es: 'Montenegro',
    nationality_pt: 'Montenegrino(a)',
    nationality_es: 'Montenegrino(a)',
  },
  {
    num_code: '500',
    alpha_2_code: 'MS',
    alpha_3_code: 'MSR',
    country_en: 'Montserrat',
    nationality_en: 'Montserratian',
    country_pt: 'Montserado',
    country_es: 'Montserado',
    nationality_pt: 'Montseradense(a)',
    nationality_es: 'Montserandés(a)',
  },
  {
    num_code: '504',
    alpha_2_code: 'MA',
    alpha_3_code: 'MAR',
    country_en: 'Morocco',
    nationality_en: 'Moroccan',
    country_pt: 'Marrocos',
    country_es: 'Marruecos',
    nationality_pt: 'Marroquino(a)',
    nationality_es: 'Marroquí(a)',
  },
  {
    num_code: '508',
    alpha_2_code: 'MZ',
    alpha_3_code: 'MOZ',
    country_en: 'Mozambique',
    nationality_en: 'Mozambican',
    country_pt: 'Moçambique',
    country_es: 'Mozambique',
    nationality_pt: 'Moçambicano(a)',
    nationality_es: 'Mozambiqueño(a)',
  },
  {
    num_code: '104',
    alpha_2_code: 'MM',
    alpha_3_code: 'MMR',
    country_en: 'Myanmar',
    nationality_en: 'Burmese',
    country_pt: 'Mianmar',
    country_es: 'Myanmar',
    nationality_pt: 'Mianmar',
    nationality_es: 'Myanmar',
  },
  {
    num_code: '516',
    alpha_2_code: 'NA',
    alpha_3_code: 'NAM',
    country_en: 'Namibia',
    nationality_en: 'Namibian',
    country_pt: 'Namíbia',
    country_es: 'Namibia',
    nationality_pt: 'Namibiano(a)',
    nationality_es: 'Namibio(a)',
  },
  {
    num_code: '520',
    alpha_2_code: 'NR',
    alpha_3_code: 'NRU',
    country_en: 'Nauru',
    nationality_en: 'Nauruan',
    country_pt: 'Nauru',
    country_es: 'Nauru',
    nationality_pt: 'Nauruano(a)',
    nationality_es: 'Naurueño(a)',
  },
  {
    num_code: '524',
    alpha_2_code: 'NP',
    alpha_3_code: 'NPL',
    country_en: 'Nepal',
    nationality_en: 'Nepali, Nepalese',
    country_pt: 'Nepal',
    country_es: 'Nepal',
    nationality_pt: 'Nepalês(a)',
    nationality_es: 'Nepalés(a)',
  },
  {
    num_code: '528',
    alpha_2_code: 'NL',
    alpha_3_code: 'NLD',
    country_en: 'Netherlands',
    nationality_en: 'Dutch, Netherlandic',
    country_pt: 'Países Baixos',
    country_es: 'Países Bajos',
    nationality_pt: 'Holandês(esa)',
    nationality_es: 'Holandés(esa)',
  },
  {
    num_code: '540',
    alpha_2_code: 'NC',
    alpha_3_code: 'NCL',
    country_en: 'New Caledonia',
    nationality_en: 'New Caledonian',
    country_pt: 'Nova Caledônia',
    country_es: 'Nueva Caledonia',
    nationality_pt: 'Novocaledônio(a)',
    nationality_es: 'Neocaledonio(a)',
  },
  {
    num_code: '554',
    alpha_2_code: 'NZ',
    alpha_3_code: 'NZL',
    country_en: 'New Zealand',
    nationality_en: 'New Zealand, NZ',
    country_pt: 'Nova Zelândia',
    country_es: 'Nueva Zelanda',
    nationality_pt: 'Neozelandês(a)',
    nationality_es: 'Neozelandés(esa)',
  },
  {
    num_code: '558',
    alpha_2_code: 'NI',
    alpha_3_code: 'NIC',
    country_en: 'Nicaragua',
    nationality_en: 'Nicaraguan',
    country_pt: 'Nicarágua',
    country_es: 'Nicaragua',
    nationality_pt: 'Nicaragüense(a)',
    nationality_es: 'Nicaragüense(a)',
  },
  {
    num_code: '562',
    alpha_2_code: 'NE',
    alpha_3_code: 'NER',
    country_en: 'Niger',
    nationality_en: 'Nigerien',
    country_pt: 'Níger',
    country_es: 'Níger',
    nationality_pt: 'Nigeriano(a)',
    nationality_es: 'Nigeriano(a)',
  },
  {
    num_code: '566',
    alpha_2_code: 'NG',
    alpha_3_code: 'NGA',
    country_en: 'Nigeria',
    nationality_en: 'Nigerian',
    country_pt: 'Nigéria',
    country_es: 'Nigeria',
    nationality_pt: 'Nigério(a)',
    nationality_es: 'Nigeriano(a)',
  },
  {
    num_code: '570',
    alpha_2_code: 'NU',
    alpha_3_code: 'NIU',
    country_en: 'Niue',
    nationality_en: 'Niuean',
    country_pt: 'Niue',
    country_es: 'Niue',
    nationality_pt: 'Niue',
    nationality_es: 'Niue',
  },
  {
    num_code: '574',
    alpha_2_code: 'NF',
    alpha_3_code: 'NFK',
    country_en: 'Norfolk Island',
    nationality_en: 'Norfolk Island',
    country_pt: 'Ilha de Norfolk',
    country_es: 'Isla de Norfolk',
    nationality_pt: 'Norfolkiano(a)',
    nationality_es: 'Norfolkiano(a)',
  },
  {
    num_code: '580',
    alpha_2_code: 'MP',
    alpha_3_code: 'MNP',
    country_en: 'Northern Mariana Islands',
    nationality_en: 'Northern Marianan',
    country_pt: 'Ilhas Marianas do Norte',
    country_es: 'Islas Marianas del Norte',
    nationality_pt: 'Marianense(a)',
    nationality_es: 'Marianense(a)',
  },
  {
    num_code: '578',
    alpha_2_code: 'NO',
    alpha_3_code: 'NOR',
    country_en: 'Norway',
    nationality_en: 'Norwegian',
    country_pt: 'Noruega',
    country_es: 'Noruega',
    nationality_pt: 'Norueguês(a)',
    nationality_es: 'Noruego(a)',
  },
  {
    num_code: '512',
    alpha_2_code: 'OM',
    alpha_3_code: 'OMN',
    country_en: 'Oman',
    nationality_en: 'Omani',
    country_pt: 'Omã',
    country_es: 'Omán',
    nationality_pt: 'Omanense',
    nationality_es: 'Omaní',
  },
  {
    num_code: '586',
    alpha_2_code: 'PK',
    alpha_3_code: 'PAK',
    country_en: 'Pakistan',
    nationality_en: 'Pakistani',
    country_pt: 'Paquistão',
    country_es: 'Pakistán',
    nationality_pt: 'Paquistanês(a)',
    nationality_es: 'Paquistaní(a)',
  },
  {
    num_code: '585',
    alpha_2_code: 'PW',
    alpha_3_code: 'PLW',
    country_en: 'Palau',
    nationality_en: 'Palauan',
    country_pt: 'Palau',
    country_es: 'Palau',
    nationality_pt: 'Palauano(a)',
    nationality_es: 'Palauano(a)',
  },
  {
    num_code: '275',
    alpha_2_code: 'PS',
    alpha_3_code: 'PSE',
    country_en: 'Palestine, State of',
    nationality_en: 'Palestinian',
    country_pt: 'Palestina, Estado da',
    country_es: 'Palestina, Estado de',
    nationality_pt: 'Palestino(a)',
    nationality_es: 'Palestino(a)',
  },
  {
    num_code: '591',
    alpha_2_code: 'PA',
    alpha_3_code: 'PAN',
    country_en: 'Panama',
    nationality_en: 'Panamanian',
    country_pt: 'Panamá',
    country_es: 'Panamá',
    nationality_pt: 'Panamenho(a)',
    nationality_es: 'Panameño(a)',
  },
  {
    num_code: '598',
    alpha_2_code: 'PG',
    alpha_3_code: 'PNG',
    country_en: 'Papua New Guinea',
    nationality_en: 'Papua New Guinean, Papuan',
    country_pt: 'Papua Nova Guiné',
    country_es: 'Papúa Nueva Guinea',
    nationality_pt: 'Papua-novo-guineense',
    nationality_es: 'Papúa Nueva Guinea',
  },
  {
    num_code: '600',
    alpha_2_code: 'PY',
    alpha_3_code: 'PRY',
    country_en: 'Paraguay',
    nationality_en: 'Paraguayan',
    country_pt: 'Paraguai',
    country_es: 'Paraguay',
    nationality_pt: 'Paraguaio(a)',
    nationality_es: 'Paraguayo(a)',
  },
  {
    num_code: '604',
    alpha_2_code: 'PE',
    alpha_3_code: 'PER',
    country_en: 'Peru',
    nationality_en: 'Peruvian',
    country_pt: 'Peru',
    country_es: 'Perú',
    nationality_pt: 'Peruano(a)',
    nationality_es: 'Peruano(a)',
  },
  {
    num_code: '608',
    alpha_2_code: 'PH',
    alpha_3_code: 'PHL',
    country_en: 'Philippines',
    nationality_en: 'Philippine, Filipino',
    country_pt: 'Filipinas',
    country_es: 'Filipinas',
    nationality_pt: 'Filipino(a)',
    nationality_es: 'Filipino(a)',
  },
  {
    num_code: '612',
    alpha_2_code: 'PN',
    alpha_3_code: 'PCN',
    country_en: 'Pitcairn',
    nationality_en: 'Pitcairn Island',
    country_pt: 'Pitcairn',
    country_es: 'Pitcairn',
    nationality_pt: 'Pitcairnense',
    nationality_es: 'Pitcairnense',
  },
  {
    num_code: '616',
    alpha_2_code: 'PL',
    alpha_3_code: 'POL',
    country_en: 'Poland',
    nationality_en: 'Polish',
    country_pt: 'Polônia',
    country_es: 'Polonia',
    nationality_pt: 'Polaco(a)',
    nationality_es: 'Polaco(a)',
  },
  {
    num_code: '620',
    alpha_2_code: 'PT',
    alpha_3_code: 'PRT',
    country_en: 'Portugal',
    nationality_en: 'Portuguese',
    country_pt: 'Portugal',
    country_es: 'Portugal',
    nationality_pt: 'Português(a)',
    nationality_es: 'Portugués(a)',
  },
  {
    num_code: '630',
    alpha_2_code: 'PR',
    alpha_3_code: 'PRI',
    country_en: 'Puerto Rico',
    nationality_en: 'Puerto Rican',
    country_pt: 'Porto Rico',
    country_es: 'Puerto Rico',
    nationality_pt: 'Portorriquenho(a)',
    nationality_es: 'Portorriqueño(a)',
  },
  {
    num_code: '634',
    alpha_2_code: 'QA',
    alpha_3_code: 'QAT',
    country_en: 'Qatar',
    nationality_en: 'Qatari',
    country_pt: 'Qatar',
    country_es: 'Qatar',
    nationality_pt: 'Catari',
    nationality_es: 'Qatarí',
  },
  {
    num_code: '638',
    alpha_2_code: 'RE',
    alpha_3_code: 'REU',
    country_en: 'Réunion',
    nationality_en: 'Réunionese, Réunionnais',
    country_pt: 'Reunião',
    country_es: 'Reunión',
    nationality_pt: 'Reunionense',
    nationality_es: 'Reunionense',
  },
  {
    num_code: '642',
    alpha_2_code: 'RO',
    alpha_3_code: 'ROU',
    country_en: 'Romania',
    nationality_en: 'Romanian',
    country_pt: 'Romênia',
    country_es: 'Rumania',
    nationality_pt: 'Romeno(a)',
    nationality_es: 'Rumano(a)',
  },
  {
    num_code: '643',
    alpha_2_code: 'RU',
    alpha_3_code: 'RUS',
    country_en: 'Russian Federation',
    nationality_en: 'Russian',
    country_pt: 'Federação Russa',
    country_es: 'Federación Rusa',
    nationality_pt: 'Russo(a)',
    nationality_es: 'Ruso(a)',
  },
  {
    num_code: '646',
    alpha_2_code: 'RW',
    alpha_3_code: 'RWA',
    country_en: 'Rwanda',
    nationality_en: 'Rwandan',
    country_pt: 'Ruanda',
    country_es: 'Ruanda',
    nationality_pt: 'Rwandês(a)',
    nationality_es: 'Rwandés(a)',
  },
  {
    num_code: '652',
    alpha_2_code: 'BL',
    alpha_3_code: 'BLM',
    country_en: 'Saint Barthélemy',
    nationality_en: 'Barthélemois',
    country_pt: 'São Bartolomeu',
    country_es: 'San Bartolomé',
    nationality_pt: 'São Bartolomeu',
    nationality_es: 'San Bartolomé',
  },
  {
    num_code: '654',
    alpha_2_code: 'SH',
    alpha_3_code: 'SHN',
    country_en: 'Saint Helena, Ascension and Tristan da Cunha',
    nationality_en: 'Saint Helenian',
    country_pt: 'Santa Helena, Ascensão e Tristão da Cunha',
    country_es: 'Santa Elena, Ascensión y Tristán de Acuña',
    nationality_pt: 'Santa-Helenense(a)',
    nationality_es: 'Santaclareño(a)',
  },
  {
    num_code: '659',
    alpha_2_code: 'KN',
    alpha_3_code: 'KNA',
    country_en: 'Saint Kitts and Nevis',
    nationality_en: 'Kittitian or Nevisian',
    country_pt: 'São Cristóvão e Nevis',
    country_es: 'San Cristóbal y Nevis',
    nationality_pt: 'São-cristovalense ou Nevense',
    nationality_es: 'San-cristobalense o Nevense',
  },
  {
    num_code: '662',
    alpha_2_code: 'LC',
    alpha_3_code: 'LCA',
    country_en: 'Saint Lucia',
    nationality_en: 'Saint Lucian',
    country_pt: 'Santa Lúcia',
    country_es: 'Santa Lucía',
    nationality_pt: 'Santa-lucense(a)',
    nationality_es: 'Santa-lucense(a)',
  },
  {
    num_code: '663',
    alpha_2_code: 'MF',
    alpha_3_code: 'MAF',
    country_en: 'Saint Martin (French part)',
    nationality_en: 'Saint-Martinoise',
    country_pt: 'Saint Martin (Parte Francesa)',
    country_es: 'Saint Martin (Parte Francesa)',
    nationality_pt: 'Saint-Martinois(a)',
    nationality_es: 'Saint-Martinois(a)',
  },
  {
    num_code: '666',
    alpha_2_code: 'PM',
    alpha_3_code: 'SPM',
    country_en: 'Saint Pierre and Miquelon',
    nationality_en: 'Saint-Pierrais or Miquelonnais',
    country_pt: 'São Pedro e Miquelon',
    country_es: 'San Pedro y Miquelón',
    nationality_pt: 'São-pedrino(a)',
    nationality_es: 'Sanpedrino(a)',
  },
  {
    num_code: '670',
    alpha_2_code: 'VC',
    alpha_3_code: 'VCT',
    country_en: 'Saint Vincent and the Grenadines',
    nationality_en: 'Saint Vincentian, Vincentian',
    country_pt: 'São Vicente e Granadinas',
    country_es: 'San Vicente y las Granadinas',
    nationality_pt: 'São-vicentino(a)',
    nationality_es: 'Sanvicentino(a)',
  },
  {
    num_code: '882',
    alpha_2_code: 'WS',
    alpha_3_code: 'WSM',
    country_en: 'Samoa',
    nationality_en: 'Samoan',
    country_pt: 'Samoa',
    country_es: 'Samoa',
    nationality_pt: 'Samoano(a)',
    nationality_es: 'Samoano(a)',
  },
  {
    num_code: '674',
    alpha_2_code: 'SM',
    alpha_3_code: 'SMR',
    country_en: 'San Marino',
    nationality_en: 'Sammarinese',
    country_pt: 'San Marino',
    country_es: 'San Marino',
    nationality_pt: 'Sanmarines(a)',
    nationality_es: 'Sanmarineño(a)',
  },
  {
    num_code: '678',
    alpha_2_code: 'ST',
    alpha_3_code: 'STP',
    country_en: 'Sao Tome and Principe',
    nationality_en: 'São Toméan',
    country_pt: 'São Tomé e Príncipe',
    country_es: 'Santo Tomé y Príncipe',
    nationality_pt: 'São-tomense(a)',
    nationality_es: 'Santomeño(a)',
  },
  {
    num_code: '682',
    alpha_2_code: 'SA',
    alpha_3_code: 'SAU',
    country_en: 'Saudi Arabia',
    nationality_en: 'Saudi, Saudi Arabian',
    country_pt: 'Arábia Saudita',
    country_es: 'Arabia Saudita',
    nationality_pt: 'Arábio(a)',
    nationality_es: 'Arabio(a)',
  },
  {
    num_code: '686',
    alpha_2_code: 'SN',
    alpha_3_code: 'SEN',
    country_en: 'Senegal',
    nationality_en: 'Senegalese',
    country_pt: 'Senegal',
    country_es: 'Senegal',
    nationality_pt: 'Senegalês(a)',
    nationality_es: 'Senegalés(a)',
  },
  {
    num_code: '688',
    alpha_2_code: 'RS',
    alpha_3_code: 'SRB',
    country_en: 'Serbia',
    nationality_en: 'Serbian',
    country_pt: 'Sérvia',
    country_es: 'Serbia',
    nationality_pt: 'Serbio(a)',
    nationality_es: 'Serbio(a)',
  },
  {
    num_code: '690',
    alpha_2_code: 'SC',
    alpha_3_code: 'SYC',
    country_en: 'Seychelles',
    nationality_en: 'Seychellois',
    country_pt: 'Seychelles',
    country_es: 'Seychelles',
    nationality_pt: 'Seychellois',
    nationality_es: 'Seychellois',
  },
  {
    num_code: '694',
    alpha_2_code: 'SL',
    alpha_3_code: 'SLE',
    country_en: 'Sierra Leone',
    nationality_en: 'Sierra Leonean',
    country_pt: 'Serra Leoa',
    country_es: 'Sierra Leona',
    nationality_pt: 'Serra Leonês(a)',
    nationality_es: 'Sierraleonés(a)',
  },
  {
    num_code: '702',
    alpha_2_code: 'SG',
    alpha_3_code: 'SGP',
    country_en: 'Singapore',
    nationality_en: 'Singaporean',
    country_pt: 'Singapura',
    country_es: 'Singapur',
    nationality_pt: 'Singapuriano(a)',
    nationality_es: 'Singapuriano(a)',
  },
  {
    num_code: '534',
    alpha_2_code: 'SX',
    alpha_3_code: 'SXM',
    country_en: 'Sint Maarten (Dutch part)',
    nationality_en: 'Sint Maarten',
    country_pt: 'Sint Maarten (parte holandesa)',
    country_es: 'Sint Maarten (parte holandesa)',
    nationality_pt: 'Sint Martenho(a)',
    nationality_es: 'San Martinés(a)',
  },
  {
    num_code: '703',
    alpha_2_code: 'SK',
    alpha_3_code: 'SVK',
    country_en: 'Slovakia',
    nationality_en: 'Slovak',
    country_pt: 'Eslováquia',
    country_es: 'Eslovaquia',
    nationality_pt: 'Eslovaco(a)',
    nationality_es: 'Eslovaco(a)',
  },
  {
    num_code: '705',
    alpha_2_code: 'SI',
    alpha_3_code: 'SVN',
    country_en: 'Slovenia',
    nationality_en: 'Slovenian, Slovene',
    country_pt: 'Eslovênia',
    country_es: 'Eslovenia',
    nationality_pt: 'Esloveno(a)',
    nationality_es: 'Esloveno(a)',
  },
  {
    num_code: '90',
    alpha_2_code: 'SB',
    alpha_3_code: 'SLB',
    country_en: 'Solomon Islands',
    nationality_en: 'Solomon Island',
    country_pt: 'Ilhas Salomão',
    country_es: 'Islas Salomón',
    nationality_pt: 'Solomonense(a)',
    nationality_es: 'Solomonense(a)',
  },
  {
    num_code: '706',
    alpha_2_code: 'SO',
    alpha_3_code: 'SOM',
    country_en: 'Somalia',
    nationality_en: 'Somali, Somalian',
    country_pt: 'Somália',
    country_es: 'Somalia',
    nationality_pt: 'Somali',
    nationality_es: 'Somali',
  },
  {
    num_code: '710',
    alpha_2_code: 'ZA',
    alpha_3_code: 'ZAF',
    country_en: 'South Africa',
    nationality_en: 'South African',
    country_pt: 'África do Sul',
    country_es: 'Sudáfrica',
    nationality_pt: 'Sul-africano(a)',
    nationality_es: 'Sudafricano(a)',
  },
  {
    num_code: '239',
    alpha_2_code: 'GS',
    alpha_3_code: 'SGS',
    country_en: 'South Georgia and the South Sandwich Islands',
    nationality_en: 'South Georgia or South Sandwich Islands',
    country_pt: 'Geórgia do Sul e Ilhas Sandwich do Sul',
    country_es: 'Georgia del Sur y las Islas Sandwich del Sur',
    nationality_pt: 'Georgiano(a) do Sul e Sandvichiano(a) do Sul',
    nationality_es:
      'Georgiano(a) de Georgia del Sur y Sandvichiano(a) de las Islas Sandwich del Sur',
  },
  {
    num_code: '728',
    alpha_2_code: 'SS',
    alpha_3_code: 'SSD',
    country_en: 'South Sudan',
    nationality_en: 'South Sudanese',
    country_pt: 'Sudão do Sul',
    country_es: 'Sudán del Sur',
    nationality_pt: 'Sudanês(a)',
    nationality_es: 'Sudanés(a)',
  },
  {
    num_code: '724',
    alpha_2_code: 'ES',
    alpha_3_code: 'ESP',
    country_en: 'Spain',
    nationality_en: 'Spanish',
    country_pt: 'Espanha',
    country_es: 'España',
    nationality_pt: 'Espanhol(a)',
    nationality_es: 'Español(a)',
  },
  {
    num_code: '144',
    alpha_2_code: 'LK',
    alpha_3_code: 'LKA',
    country_en: 'Sri Lanka',
    nationality_en: 'Sri Lankan',
    country_pt: 'Sri Lanka',
    country_es: 'Sri Lanka',
    nationality_pt: 'Sri Lanka',
    nationality_es: 'Sri Lanka',
  },
  {
    num_code: '729',
    alpha_2_code: 'SD',
    alpha_3_code: 'SDN',
    country_en: 'Sudan',
    nationality_en: 'Sudanese',
    country_pt: 'Sudão',
    country_es: 'Sudán',
    nationality_pt: 'Sudanês(a)',
    nationality_es: 'Sudanés(a)',
  },
  {
    num_code: '740',
    alpha_2_code: 'SR',
    alpha_3_code: 'SUR',
    country_en: 'Suriname',
    nationality_en: 'Surinamese',
    country_pt: 'Suriname',
    country_es: 'Surinam',
    nationality_pt: 'Surinamense',
    nationality_es: 'Surinamense',
  },
  {
    num_code: '744',
    alpha_2_code: 'SJ',
    alpha_3_code: 'SJM',
    country_en: 'Svalbard and Jan Mayen',
    nationality_en: 'Svalbard',
    country_pt: 'Espetáculo de Svalbard e Jan Mayen',
    country_es: 'Espetáculo de Svalbard y Jan Mayen',
    nationality_pt: 'Espetáculo de Svalbard e Jan Mayen',
    nationality_es: 'Espetáculo de Svalbard y Jan Mayen',
  },
  {
    num_code: '748',
    alpha_2_code: 'SZ',
    alpha_3_code: 'SWZ',
    country_en: 'Swaziland',
    nationality_en: 'Swazi',
    country_pt: 'Suazilândia',
    country_es: 'Suazilandia',
    nationality_pt: 'Suazilandês(a)',
    nationality_es: 'Suazilandés(a)',
  },
  {
    num_code: '752',
    alpha_2_code: 'SE',
    alpha_3_code: 'SWE',
    country_en: 'Sweden',
    nationality_en: 'Swedish',
    country_pt: 'Suécia',
    country_es: 'Suecia',
    nationality_pt: 'Sueco(a)',
    nationality_es: 'Sueco(a)',
  },
  {
    num_code: '756',
    alpha_2_code: 'CH',
    alpha_3_code: 'CHE',
    country_en: 'Switzerland',
    nationality_en: 'Swiss',
    country_pt: 'Suíça',
    country_es: 'Suiza',
    nationality_pt: 'Suíço(a)',
    nationality_es: 'Suizo(a)',
  },
  {
    num_code: '760',
    alpha_2_code: 'SY',
    alpha_3_code: 'SYR',
    country_en: 'Syrian Arab Republic',
    nationality_en: 'Syrian',
    country_pt: 'República Árabe da Síria',
    country_es: 'República Árabe Siria',
    nationality_pt: 'Sírio(a)',
    nationality_es: 'Sirio(a)',
  },
  {
    num_code: '158',
    alpha_2_code: 'TW',
    alpha_3_code: 'TWN',
    country_en: 'Taiwan, Province of China',
    nationality_en: 'Chinese, Taiwanese',
    country_pt: 'Taiwan',
    country_es: 'Taiwán',
    nationality_pt: 'Taiwanês(esa)',
    nationality_es: 'Taiwán',
  },
  {
    num_code: '762',
    alpha_2_code: 'TJ',
    alpha_3_code: 'TJK',
    country_en: 'Tajikistan',
    nationality_en: 'Tajikistani',
    country_pt: 'Tajiquistão',
    country_es: 'Tayikistán',
    nationality_pt: 'Tajique',
    nationality_es: 'Tayiko',
  },
  {
    num_code: '834',
    alpha_2_code: 'TZ',
    alpha_3_code: 'TZA',
    country_en: 'Tanzania, United Republic of',
    nationality_en: 'Tanzanian',
    country_pt: 'Tanzânia, República Unida',
    country_es: 'Tanzania, República Unida',
    nationality_pt: 'Tanzaniano(a)',
    nationality_es: 'Tanzano(a)',
  },
  {
    num_code: '764',
    alpha_2_code: 'TH',
    alpha_3_code: 'THA',
    country_en: 'Thailand',
    nationality_en: 'Thai',
    country_pt: 'Tailândia',
    country_es: 'Tailandia',
    nationality_pt: 'Tailandês(esa)',
    nationality_es: 'Tailandés(esa)',
  },
  {
    num_code: '626',
    alpha_2_code: 'TL',
    alpha_3_code: 'TLS',
    country_en: 'Timor-Leste',
    nationality_en: 'Timorese',
    country_pt: 'Timor-Leste',
    country_es: 'Timor Oriental',
    nationality_pt: 'Timorense(a)',
    nationality_es: 'Timorense(a)',
  },
  {
    num_code: '768',
    alpha_2_code: 'TG',
    alpha_3_code: 'TGO',
    country_en: 'Togo',
    nationality_en: 'Togolese',
    country_pt: 'Togo',
    country_es: 'Togo',
    nationality_pt: 'Toguenho(a)',
    nationality_es: 'Toguenho(a)',
  },
  {
    num_code: '772',
    alpha_2_code: 'TK',
    alpha_3_code: 'TKL',
    country_en: 'Tokelau',
    nationality_en: 'Tokelauan',
    country_pt: 'Tokelau',
    country_es: 'Tokelau',
    nationality_pt: 'Tokelau',
    nationality_es: 'Tokelau',
  },
  {
    num_code: '776',
    alpha_2_code: 'TO',
    alpha_3_code: 'TON',
    country_en: 'Tonga',
    nationality_en: 'Tongan',
    country_pt: 'Tonga',
    country_es: 'Tonga',
    nationality_pt: 'Tonguês(a)',
    nationality_es: 'Tongués(a)',
  },
  {
    num_code: '780',
    alpha_2_code: 'TT',
    alpha_3_code: 'TTO',
    country_en: 'Trinidad and Tobago',
    nationality_en: 'Trinidadian or Tobagonian',
    country_pt: 'Trinidad e Tobago',
    country_es: 'Trinidad y Tobago',
    nationality_pt: 'Trinidade e Tobago',
    nationality_es: 'Trinidad y Tobago',
  },
  {
    num_code: '788',
    alpha_2_code: 'TN',
    alpha_3_code: 'TUN',
    country_en: 'Tunisia',
    nationality_en: 'Tunisian',
    country_pt: 'Tunísia',
    country_es: 'Túnez',
    nationality_pt: 'Tunisiano(a)',
    nationality_es: 'Tunecino(a)',
  },
  {
    num_code: '792',
    alpha_2_code: 'TR',
    alpha_3_code: 'TUR',
    country_en: 'Turkey',
    nationality_en: 'Turkish',
    country_pt: 'Turquia',
    country_es: 'Turquía',
    nationality_pt: 'Turco(a)',
    nationality_es: 'Turco(a)',
  },
  {
    num_code: '795',
    alpha_2_code: 'TM',
    alpha_3_code: 'TKM',
    country_en: 'Turkmenistan',
    nationality_en: 'Turkmen',
    country_pt: 'Turcomenistão',
    country_es: 'Turkmenistán',
    nationality_pt: 'Turcomeno(a)',
    nationality_es: 'Turcomeno(a)',
  },
  {
    num_code: '796',
    alpha_2_code: 'TC',
    alpha_3_code: 'TCA',
    country_en: 'Turks and Caicos Islands',
    nationality_en: 'Turks and Caicos Island',
    country_pt: 'Ilhas Turcas e Caicos',
    country_es: 'Islas Turcas y Caicos',
    nationality_pt: 'Turco e Caicosiano(a)',
    nationality_es: 'Turco y Caicosiano(a)',
  },
  {
    num_code: '798',
    alpha_2_code: 'TV',
    alpha_3_code: 'TUV',
    country_en: 'Tuvalu',
    nationality_en: 'Tuvaluan',
    country_pt: 'Tuvalu',
    country_es: 'Tuvalu',
    nationality_pt: 'Tuvalense',
    nationality_es: 'Tuvaldense',
  },
  {
    num_code: '800',
    alpha_2_code: 'UG',
    alpha_3_code: 'UGA',
    country_en: 'Uganda',
    nationality_en: 'Ugandan',
    country_pt: 'Uganda',
    country_es: 'Uganda',
    nationality_pt: 'Ugandense',
    nationality_es: 'Ugandés',
  },
  {
    num_code: '804',
    alpha_2_code: 'UA',
    alpha_3_code: 'UKR',
    country_en: 'Ukraine',
    nationality_en: 'Ukrainian',
    country_pt: 'Ucrânia',
    country_es: 'Ucrania',
    nationality_pt: 'Ucraniano(a)',
    nationality_es: 'Ucraniano(a)',
  },
  {
    num_code: '784',
    alpha_2_code: 'AE',
    alpha_3_code: 'ARE',
    country_en: 'United Arab Emirates',
    nationality_en: 'Emirati, Emirian, Emiri',
    country_pt: 'Emirados Árabes Unidos',
    country_es: 'Emiratos Árabes Unidos',
    nationality_pt: 'Emiradense',
    nationality_es: 'Emiriano',
  },
  {
    num_code: '826',
    alpha_2_code: 'GB',
    alpha_3_code: 'GBR',
    country_en: 'United Kingdom of Great Britain and Northern Ireland',
    nationality_en: 'British, UK',
    country_pt: 'Reino Unido da Grã-Bretanha e Irlanda do Norte',
    country_es: 'Reino Unido de Gran Bretaña e Irlanda del Norte',
    nationality_pt: 'Britânico(a)',
    nationality_es: 'Británico(a)',
  },
  {
    num_code: '581',
    alpha_2_code: 'UM',
    alpha_3_code: 'UMI',
    country_en: 'United States Minor Outlying Islands',
    nationality_en: 'American UMI',
    country_pt: 'Ilhas Menores Distantes dos Estados Unidos',
    country_es: 'Islas Menores Distantes de los Estados Unidos',
    nationality_pt: 'Ilhas Menores Distantes dos Estados Unidos',
    nationality_es: 'Islas Menores Distantes de los Estados Unidos',
  },
  {
    num_code: '840',
    alpha_2_code: 'US',
    alpha_3_code: 'USA',
    country_en: 'United States of America',
    nationality_en: 'American',
    country_pt: 'Estados Unidos da América',
    country_es: 'Estados Unidos de América',
    nationality_pt: 'Americano(a)',
    nationality_es: 'Americano(a)',
  },
  {
    num_code: '858',
    alpha_2_code: 'UY',
    alpha_3_code: 'URY',
    country_en: 'Uruguay',
    nationality_en: 'Uruguayan',
    country_pt: 'Uruguai',
    country_es: 'Uruguay',
    nationality_pt: 'Uruguaiu(a)',
    nationality_es: 'Uruguayo(a)',
  },
  {
    num_code: '860',
    alpha_2_code: 'UZ',
    alpha_3_code: 'UZB',
    country_en: 'Uzbekistan',
    nationality_en: 'Uzbekistani, Uzbek',
    country_pt: 'Uzbequistão',
    country_es: 'Uzbekistán',
    nationality_pt: 'Uzbeque(a)',
    nationality_es: 'Uzbeko(a)',
  },
  {
    num_code: '548',
    alpha_2_code: 'VU',
    alpha_3_code: 'VUT',
    country_en: 'Vanuatu',
    nationality_en: 'Ni-Vanuatu, Vanuatuan',
    country_pt: 'Vanuatu',
    country_es: 'Vanuatu',
    nationality_pt: 'Vanuatu',
    nationality_es: 'Vanuatu',
  },
  {
    num_code: '862',
    alpha_2_code: 'VE',
    alpha_3_code: 'VEN',
    country_en: 'Venezuela (Bolivarian Republic of)',
    nationality_en: 'Venezuelan',
    country_pt: 'Venezuela',
    country_es: 'Venezuela',
    nationality_pt: 'Venezuelano(a)',
    nationality_es: 'Venezolano(a)',
  },
  {
    num_code: '704',
    alpha_2_code: 'VN',
    alpha_3_code: 'VNM',
    country_en: 'Vietnam',
    nationality_en: 'Vietnamese',
    country_pt: 'Vietnã',
    country_es: 'Vietnam',
    nationality_pt: 'Vietnamita',
    nationality_es: 'Vietnamita',
  },
  {
    num_code: '92',
    alpha_2_code: 'VG',
    alpha_3_code: 'VGB',
    country_en: 'Virgin Islands (British)',
    nationality_en: 'British Virgin Island',
    country_pt: 'Ilhas Virgens Britânicas',
    country_es: 'Islas Vírgenes Británicas',
    nationality_pt: 'Virginense(a)',
    nationality_es: 'Virgen(a)',
  },
  {
    num_code: '850',
    alpha_2_code: 'VI',
    alpha_3_code: 'VIR',
    country_en: 'Virgin Islands (U.S.)',
    nationality_en: 'U.S. Virgin Island',
    country_pt: 'Ilhas Virgens (EUA)',
    country_es: 'Islas Vírgenes (Estados Unidos)',
    nationality_pt: 'Virginense(a)',
    nationality_es: 'Virgense(a)',
  },
  {
    num_code: '876',
    alpha_2_code: 'WF',
    alpha_3_code: 'WLF',
    country_en: 'Wallis and Futuna',
    nationality_en: 'Wallis and Futuna, Wallisian or Futunan',
    country_pt: 'Wallis e Futuna',
    country_es: 'Wallis y Futuna',
    nationality_pt: 'Wallis e Futuna',
    nationality_es: 'Wallis y Futuna',
  },
  {
    num_code: '732',
    alpha_2_code: 'EH',
    alpha_3_code: 'ESH',
    country_en: 'Western Sahara',
    nationality_en: 'Sahrawi, Sahrawian, Sahraouian',
    country_pt: 'Saara Ocidental',
    country_es: 'Saara Occidental',
    nationality_pt: 'Saara Ocidental',
    nationality_es: 'Saara Occidental',
  },
  {
    num_code: '887',
    alpha_2_code: 'YE',
    alpha_3_code: 'YEM',
    country_en: 'Yemen',
    nationality_en: 'Yemeni',
    country_pt: 'Iêmen',
    country_es: 'Yemen',
    nationality_pt: 'Iemenita',
    nationality_es: 'Yemén',
  },
  {
    num_code: '894',
    alpha_2_code: 'ZM',
    alpha_3_code: 'ZMB',
    country_en: 'Zambia',
    nationality_en: 'Zambian',
    country_pt: 'Zâmbia',
    country_es: 'Zambia',
    nationality_pt: 'Zambiano(a)',
    nationality_es: 'Zambiano(a)',
  },
  {
    num_code: '716',
    alpha_2_code: 'ZW',
    alpha_3_code: 'ZWE',
    country_en: 'Zimbabwe',
    nationality_en: 'Zimbabwean',
    country_pt: 'Zimbábue',
    country_es: 'Zimbabue',
    nationality_pt: 'Zimbabuano(a)',
    nationality_es: 'Zimbabuano(a)',
  },
]
